import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { toast } from "react-toastify";

const PrivateRoute = ({ requiredRole }) => {
  const token = localStorage.getItem("auth-token");

  if (!token) {
    toast.error("No token found");
    return <Navigate to="/adminuser" replace />;
  }

  const payloadBase64 = token.split(".")[1];

  try {
    const decodedPayload = JSON.parse(atob(payloadBase64));
    const userRole = decodedPayload.role;
    const tokenExp = decodedPayload.exp;

    const currentTime = Math.floor(Date.now() / 1000);

    if (tokenExp && currentTime > tokenExp) {
      toast.error("Session expired, please log in again.");
      localStorage.removeItem("auth-token");
      return <Navigate to="/adminuser" replace />;
    }

    if (requiredRole && userRole !== requiredRole) {
      toast.error("Unauthorized access");
      return <Navigate to="/unauthorized" replace />;
    }

    // Token is valid and role matches
    return <Outlet />;
  } catch (error) {
    toast.error("Invalid token");
    localStorage.removeItem("auth-token");
    return <Navigate to="/adminuser" replace />;
  }
};

export default PrivateRoute;
